export default __webpack_public_path__ + "static/media/Celsius.b866ee77.jpg";